import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import NewHeader from '../../NewHome/components/Header';
import {
  LOCAL_STORAGE_CONSTANT,
  MODAL_TYPE,
  IMAGE_CONSTANT,
} from '../../../constants/app';
import axios from 'axios';
import parser from 'html-react-parser';
import useWindowWidth from '../../../hooks/useWindowWidth';
import {
  blogContentParser,
  blogImageUrl,
  getDisplayType,
  getFormatterContent,
  isLoggedIn,
  logOutput,
  scrollToTop,
} from '../../../utils/helpers';
import { removeItem } from '../../../utils/cache';
import { SEGMENT_EVENTS, trackEvent } from '../../../utils/Segment';
import { extractJSON } from '../../../services/jsonUtil';
import { Wrapper } from '../../NewHome';
import Login from '../../NewHome/components/Login';
import OtpModal from '../../NewHome/components/OtpModal';
import SignUp from '../../NewHome/components/SignUp';
import SuccessModal from '../../NewHome/components/SuccessModal';
import WaitList from '../../NewHome/components/WaitList';
import Modal from '../../NewHome/components/Modal';
import SeoTags from '../../../components/SeoComponent';
import { SeoTexts } from '../../../services/SEO';
// import { APP_ROUTES } from '../../../route';

import SearchBox from '../components/SearchBox';
import Footer from '../components/RightSection/Footer';
import './style.css';
import {
  doFetchAllPodcastCategoryRequest,
  doFetchAllPodcastRequest,
  doFetchDetailPodcastRequest,
  doFetchDetailPodcastSuccess,
} from '../../../store/action/podcast';
import { doGetPublicCoursesRequest } from '../../../store/action/challengesAndCourses';
import { doFetchBlogsByCategoryRequest } from '../../../store/action/blog';
import TopEpisodes from '../components/TopEpisodes';
import PodcastsCategories from '../components/Categories';
import FolderSkeleton from '../../../ui-core/Skeletons/FolderSkeleton';
import LazyImage from '../../../ui-core/Image';
import Header from '../../../components/Header';
import EmailForm from '../components/EmailForm';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import DetailPageSkeleton from '../../../ui-core/Skeletons/DetailPageSkeletion';
import { requestGetPodcastDetailAuthor } from '../../../api/strapi';
import PodcastBlogSponsor from '../../../components/PodcastBlogSponsors';
// import { toast } from 'react-toastify';

function DetailPage() {
  const [modalState, setModalState] = useState(null);
  const [countryCode, setCountryCode] = useState('us');
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const handleModalState = modalData => setModalState(modalData);
  const handleModalEvent = modalType => setModalState(modalType);
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [authorImageData, setAuthorImageData] = useState();
  const {
    detailPodcast = null,
    podcasts = [],
    podcastsCategory,
    isPodcastDetailLoading: isPodcastLoading,
  } = useSelector(state => state.podcasts);
  const renderSkeletons = [1, 2, 3].map(item => (
    <div key={item} className="col-12 col-md-4 items">
      <FolderSkeleton key={item} />
    </div>
  ));

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then(response => {
        const data = response.data;
        setCountryCode(data.country_code.toLowerCase());
      })
      .catch(error => {
        logOutput(error);
      });
    return () => {
      dispatch(doFetchDetailPodcastSuccess({}));
    };
  }, []);

  useEffect(() => {
    if (!isPodcastLoading && detailPodcast && detailPodcast?.message) {
      toast.error(detailPodcast?.message);
      dispatch(doFetchDetailPodcastSuccess({}));
      history.push('/podcasts');
    }
  }, [detailPodcast, isPodcastLoading]);

  // useEffect(() => {
  //   if (detailPodcast !== null && Object.keys(detailPodcast)?.length === 0) {
  //     toast.error('Episode not found, please check episode number');
  //     history.push('/podcasts');
  //   }
  // }, [detailPodcast]);

  const categoryName = id => {
    const name =
      podcasts !== null
        ? podcasts.find(item => {
            return '' + params.name === '' + item?.attributes?.episode;
          })
        : '';

    return name?.attributes?.categories?.data[0]?.attributes?.name;
  };

  useEffect(() => {
    scrollToTop();
    if (params?.name) {
      dispatch(doGetPublicCoursesRequest());
      dispatch(doFetchAllPodcastCategoryRequest());
      dispatch(doFetchDetailPodcastRequest(params.name));
      dispatch(doFetchAllPodcastRequest());
      dispatch(
        doFetchBlogsByCategoryRequest({ param: categoryName(params.name) }),
      );
      requestGetPodcastDetailAuthor(params.name, true)
        .then(res => {
          if (res?.data?.length) {
            setAuthorImageData(res?.data[0]?.attributes?.author);
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [params?.name]);

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      default:
        return undefined;
    }
  })();

  const handleClose = () => {
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
    setModalState(false);
  };

  const handleAuthFlow = (buttonTitle, eventType, section) => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: buttonTitle,
      page: 'Podcasts Page',
      section_title: `${section}`,
    });
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    if (!user) {
      trackEvent(SEGMENT_EVENTS.AUTH_FLOW_INITIATED, {
        page: 'Podcasts Page',
        section_title: `${section}`,
      });
      handleModalEvent(eventType);
      if (isMobileScreen) {
        scrollToTop();
      }
    }
  };
  const renderModalContent = () => {
    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <Login
              page="Podcasts Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <OtpModal
              page="Podcasts Page"
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <SignUp
              page="Podcasts Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SUCCESS:
        return <SuccessModal />;
      case MODAL_TYPE.WAITLIST:
        return <WaitList />;
      default:
        return null;
    }
  };

  const renderPageContent = () => {
    return (
      <div>
        {isLoggedIn() ? (
          <Header
            homeClass="home"
            challengeClass="challenge"
            foldersClass="folders"
            podcastClass="active"
            hideBackButton={true}
            showBackHeader={true}
            mobileHeaderText="Podcast"
            iPadHeaderText="Podcast"
            discoverClass="discover"
          />
        ) : (
          <NewHeader podcastClass="active" onClick={handleAuthFlow} />
        )}
        <div>
          <div className="podcast-detail-head">
            <div className="page-container py-0">
              <div className="row">
                <div className="col-12 col-sm-9 col-lg-4 order1-mob d-flex align-items-center">
                  {/* <img src={IMAGE_CONSTANT.gymGirl} alt="" className="w-100" /> */}
                  {((detailPodcast?.attributes?.thumbnail?.data?.attributes
                    ?.formats?.medium?.url ||
                    detailPodcast?.attributes?.thumbnail?.data?.attributes
                      ?.url) && (
                    <LazyImage
                      className="w-100 podcast-main-img object-contain"
                      src={
                        blogImageUrl +
                        (detailPodcast?.attributes?.thumbnail?.data?.attributes
                          ?.formats?.medium?.url ||
                          detailPodcast?.attributes?.thumbnail?.data?.attributes
                            ?.url)
                      }
                      errorSrc={IMAGE_CONSTANT.placeholderImage}
                      placeholderSrc={IMAGE_CONSTANT.placeholderImage}
                    />
                  )) || (
                    <LazyImage
                      className="w-100 podcast-main-img object-contain"
                      src={IMAGE_CONSTANT.placeholderImage}
                      errorSrc={IMAGE_CONSTANT.placeholderImage}
                      placeholderSrc={IMAGE_CONSTANT.placeholderImage}
                    />
                  )}
                </div>

                <div className="col-12 col-sm-9 col-lg-6 pe-xl-5 order1">
                  {isPodcastLoading && <FolderSkeleton />}

                  {!isPodcastLoading && (
                    <>
                      {' '}
                      <ul className="d-flex ps-0 top-list">
                        <li>Episode {detailPodcast?.attributes?.episode}</li>
                        <li>
                          {dayjs(
                            detailPodcast?.attributes?.podcastLiveDate ||
                              detailPodcast?.attributes?.createdAt,
                          ).format('MMM D, YYYY')}
                        </li>
                        <li>{detailPodcast?.attributes?.duration} mins</li>
                      </ul>
                      <h2>{detailPodcast?.attributes?.title}</h2>
                      <div className="d-flex align-items-center mt-4">
                        {/* <button type="button" className="stroke-btn me-4">
                      Play Episode
                      <img src={IMAGE_CONSTANT.rightAngle} alt="" />
                    </button>
                    <a href="#" className="link-txt">
                      Read transcript
                    </a> */}
                        <div className="spotify-podcast-embed-container">
                          {detailPodcast?.attributes?.urls?.spotify_embed && (
                            <iframe
                              src={
                                detailPodcast?.attributes?.urls?.spotify_embed
                              }
                              className="spotify-podcast-embed-container"
                              style={{
                                overflow: 'hidden',
                                border: '0',
                                // width: '100%',
                                // height: '100%',
                              }}
                              width="800px"
                              height="175px"
                              scrolling="no"
                            ></iframe>
                          )}
                        </div>
                      </div>
                      <div className="listen-on">
                        or listen on
                        <ul className="list-inline">
                          {detailPodcast?.attributes?.urls?.apple && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.apple
                                }
                                href={detailPodcast?.attributes?.urls?.apple}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.applePodcasts}
                                  alt="Apple Podcasts"
                                />
                              </a>
                            </li>
                          )}

                          {detailPodcast?.attributes?.urls?.soundcloud && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.soundcloud
                                }
                                href={
                                  detailPodcast?.attributes?.urls?.soundcloud
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.soundCloud}
                                  alt="Sound Cloud"
                                />
                              </a>
                            </li>
                          )}

                          {detailPodcast?.attributes?.urls?.spotify && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.spotify
                                }
                                href={detailPodcast?.attributes?.urls?.spotify}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.spotify}
                                  alt="Spotify"
                                />
                              </a>
                            </li>
                          )}

                          {/* {detailPodcast?.attributes?.urls?.google && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.google
                                }
                                href={detailPodcast?.attributes?.urls?.google}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.googlePodcasts}
                                  alt="Google Podcasts"
                                />
                              </a>
                            </li>
                          )} */}

                          {detailPodcast?.attributes?.urls?.youtube && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.youtube
                                }
                                href={detailPodcast?.attributes?.urls?.youtube}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.youtube}
                                  alt="Youtube"
                                />
                              </a>
                            </li>
                          )}

                          {detailPodcast?.attributes?.urls?.stitcher && (
                            <li>
                              <a
                                disabled={
                                  !detailPodcast?.attributes?.urls?.stitcher
                                }
                                href={detailPodcast?.attributes?.urls?.stitcher}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={IMAGE_CONSTANT.stitcher}
                                  alt="Stitcher"
                                />
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-sm-2">
                  <img
                    src={IMAGE_CONSTANT.optimalBody}
                    alt="Optimal Body"
                    className="optimal-body"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-grey">
            <div className="page-container d-flex flex-wrap">
              <section className="col-12 col-lg-9 pe-0 pe-lg-5">
                <div className="podcast-detail-info">
                  {isPodcastLoading && <DetailPageSkeleton />}

                  {detailPodcast &&
                    parser(
                      getFormatterContent(detailPodcast?.attributes?.summary),
                    )}
                  {detailPodcast &&
                    parser(
                      getFormatterContent(
                        detailPodcast?.attributes?.transcript,
                      ),
                    )}
                  <div className="podcast-author pt-4">
                    {detailPodcast?.attributes?.author?.name && (
                      <div className="author-section w-100 bg-white bg-white p-4">
                        <div className="row">
                          <div className="col-12">
                            <h4>{detailPodcast?.attributes?.author?.name}</h4>
                          </div>
                          <div className="col-12 col-sm-3">
                            <LazyImage
                              className="w-100 author-img"
                              src={
                                blogImageUrl +
                                authorImageData?.image?.data?.attributes?.url
                              }
                              errorSrc={IMAGE_CONSTANT.placeholderImage}
                              placeholderSrc={IMAGE_CONSTANT.placeholderImage}
                            />
                          </div>
                          <div className="col-12 col-sm-9">
                            <p>{detailPodcast?.attributes?.author?.bio}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="podcast-content py-4">
                    {detailPodcast &&
                      parser(
                        getFormatterContent(detailPodcast?.attributes?.content),
                      )}
                  </div>
                </div>
              </section>
              <section className="col-12 col-lg-3 ps-0 ps-sm-2 pt-4 pt-sm-5 pt-lg-0">
                <div className="d-flex flex-wrap">
                  <div className="col-12 mb-4 mb-sm-5 mb-lg-4">
                    <SearchBox className="blogs-search-input" />
                  </div>

                  <div className="col-md-6 col-lg-12 mb-0 mb-lg-5 white-card">
                    <h2 className="sub-head">Top Episodes</h2>
                    <TopEpisodes />
                  </div>

                  <div className="col-md-5 col-lg-12 categories">
                    <PodcastsCategories podcastsCategory={podcastsCategory} />
                  </div>

                  <div className="col-12">
                    <Footer onClick={handleAuthFlow} />
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div>
            <section className="col-12">
              <div className="page-container">
                <div className="related-episodes">
                  <h2>Related Episodes</h2>
                  <div className="row">
                    {!podcasts && renderSkeletons}
                    {podcasts?.slice(0, 3).map(podcastItem => {
                      const newSrc =
                        podcastItem?.attributes?.thumbnail?.data?.attributes
                          ?.url === undefined
                          ? IMAGE_CONSTANT.lowImpactBannerWebp
                          : blogImageUrl +
                            podcastItem?.attributes?.thumbnail?.data?.attributes
                              ?.url;
                      return (
                        <div
                          role="button"
                          tabIndex={0}
                          onKeyDown={() => {
                            history.push(
                              `/podcast/${podcastItem?.attributes?.episode}`,
                            );
                          }}
                          onClick={() =>
                            history.push(
                              `/podcast/${podcastItem?.attributes?.episode}`,
                            )
                          }
                          key={podcastItem.id}
                          className="col-12 col-md-4 items"
                        >
                          <LazyImage
                            src={newSrc}
                            errorSrc={IMAGE_CONSTANT.placeholderImage}
                            placeholderSrc={IMAGE_CONSTANT.placeholderImage}
                          />
                          <ul className="d-flex ps-0 mt-3">
                            <li>Episode {podcastItem?.attributes?.episode}</li>
                            <li>
                              {dayjs(
                                podcastItem?.attributes?.podcastLiveDate ||
                                  podcastItem?.attributes?.createdAt,
                              ).format('MMM D, YYYY')}
                            </li>
                          </ul>
                          <h4>{podcastItem?.attributes?.title}</h4>
                          <p>
                            {Object.keys(podcastItem).length > 0 &&
                              blogContentParser(
                                podcastItem?.attributes?.summary,
                              ).slice(0, 100)}
                            <span>...</span>
                            <a>Read More</a>
                          </p>
                          <button type="button" className="stroke-btn me-4">
                            tune in now
                            <span>
                              <img src={IMAGE_CONSTANT.rightAngle} alt="" />
                            </span>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="new-podcast-detail position-relative">
                <div className="page-container py-0">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <h3>
                        {/* <small>Sign Up For</small>  */}
                        Free Low Back Pain Guide{' '}
                        <span>27-pages to help you get to the root cause!</span>
                      </h3>
                    </div>
                    <div className="col-sm-6">
                      <div className="podcast-email">
                        <EmailForm />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {/* <div className="page-container py-0">
                  <div className="sponsored-products">
                    <h3>Sponsored Products</h3>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="img-block">
                          <img src={IMAGE_CONSTANT.ProductItem} alt="Shoes" />
                        </div>
                        <h4>Vivo Barefoot Sports Shoes</h4>
                        <p>Primus lite running trainer</p>
                        <button type="button">Add</button>
                      </div>

                      <div className="col-sm-3">
                        <div className="img-block">
                          <img src={IMAGE_CONSTANT.ProductItem} alt="Shoes" />
                        </div>
                        <h4>Vivo Barefoot Sports Shoes</h4>
                        <p>Primus lite running trainer</p>
                        <button type="button">Add</button>
                      </div>

                      <div className="col-sm-3">
                        <div className="img-block">
                          <img src={IMAGE_CONSTANT.ProductItem} alt="Shoes" />
                        </div>
                        <h4>Vivo Barefoot Sports Shoes</h4>
                        <p>Primus lite running trainer</p>
                        <button type="button">Add</button>
                      </div>

                      <div className="col-sm-3">
                        <div className="img-block">
                          <img src={IMAGE_CONSTANT.ProductItem} alt="Shoes" />
                        </div>
                        <h4>Vivo Barefoot Sports Shoes</h4>
                        <p>Primus lite running trainer</p>
                        <button type="button">Add</button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <PodcastBlogSponsor />
            </section>
          </div>
        </div>
      </div>
    );
  };

  const renderContentMobile = () => {
    if (modalState) {
      return renderModalContent();
    } else {
      return renderPageContent();
    }
  };
  const seoTags = !isPodcastLoading && detailPodcast?.attributes?.seo;
  return (
    <div className={clsx('main', isMobileScreen && modalState && 'h-100')}>
      {isMobileScreen &&
      ![MODAL_TYPE.SUCCESS, MODAL_TYPE.WAITLIST].includes(modalState)
        ? renderContentMobile()
        : renderPageContent()}
      {!isMobileScreen && (
        <Modal
          dialogClassName={dialogClassName}
          show={Boolean(modalState)}
          handleClose={handleClose}
        >
          {renderModalContent()}
        </Modal>
      )}
      {!isPodcastLoading && seoTags?.length > 0 ? (
        <SeoTags
          title={seoTags[0].metaTitle || SeoTexts.PDOCASTS_PAGE_TITLE}
          metaDescription={
            seoTags[0].metaDescription || SeoTexts.PDOCASTS_PAGE_DESCRIPTION
          }
          canonicalLink={
            `https://jen.health/podcast/` + detailPodcast?.attributes?.episode
          }
          ogImgUrl={
            blogImageUrl +
              detailPodcast?.attributes?.thumbnail?.data?.attributes?.url ||
            SeoTexts.PDOCASTS_PAGE_OG_IMAGE_URL
          }
          twitterImgUrl={
            blogImageUrl +
              detailPodcast?.attributes?.thumbnail?.data?.attributes?.url ||
            SeoTexts.PDOCASTS_PAGE_TWITTER_IMAGE_URL
          }
        />
      ) : (
        <SeoTags
          title={
            detailPodcast?.attributes?.title || SeoTexts.PDOCASTS_PAGE_TITLE
          }
          metaDescription={
            detailPodcast?.attributes?.content ||
            SeoTexts.PDOCASTS_PAGE_DESCRIPTION
          }
          canonicalLink={
            `https://jen.health/podcast/` + detailPodcast?.attributes?.episode
          }
          ogImgUrl={
            blogImageUrl +
              detailPodcast?.attributes?.thumbnail?.data?.attributes?.url ||
            SeoTexts.PDOCASTS_PAGE_OG_IMAGE_URL
          }
          twitterImgUrl={
            blogImageUrl +
              detailPodcast?.attributes?.thumbnail?.data?.attributes?.url ||
            SeoTexts.PDOCASTS_PAGE_TWITTER_IMAGE_URL
          }
        />
      )}
    </div>
  );
}

DetailPage.propTypes = {
  history: PropTypes.object,
};

export default DetailPage;
